import type { SVGProps } from "react";
import * as React from "react";

const SvgFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13 2 .707-.707A1 1 0 0 0 13 1zM6 2V1zM4 4H3zm0 16H3zM20 9h1a1 1 0 0 0-.293-.707zm-7 0h-1a1 1 0 0 0 1 1zm0-8H6v2h7zM6 1a3 3 0 0 0-2.121.879l1.414 1.414A1 1 0 0 1 6 3zm-2.121.879A3 3 0 0 0 3 4h2a1 1 0 0 1 .293-.707zM3 4v16h2V4zm0 16a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 5 20zm.879 2.121A3 3 0 0 0 6 23v-2a1 1 0 0 1-.707-.293zM6 23h12v-2H6zm12 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 18 21zm2.121-.879A3 3 0 0 0 21 20h-2a1 1 0 0 1-.293.707zM21 20V9h-2v11zm-.293-11.707-7-7-1.414 1.414 7 7zM12 2v7h2V2zm1 8h7V8h-7z"
    />
  </svg>
);
export default SvgFile;
